import React from 'react';
import CatalogPartnerCard from './CatalogPartnerCard';
import {graphql, QueryRenderer} from 'react-relay';
import RelayService from '../../service/RelayService';

export default class CatalogPartnerCardLoader extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      show: false,
    }
  }

  render() {
    let {
      documentId,
    } = this.props;

    return (
      <QueryRenderer
        environment={RelayService.environment}
        query={graphql`
        query CatalogPartnerCardLoaderQuery($documentId: String) {
            viewer {
                userId
                user {
                  mailAddress
                }
                cloudPartnerCatalog(documentId: $documentId) {
                    documentId
                    available
                    status
                }
            }
        }
      `}
        variables={{
          documentId: documentId,
        }}
        render={({ error, props }) => {
          if (error) {
            return <div>{error.message}</div>;
          } else if (props) {
            let available = props.viewer.cloudPartnerCatalog.available;
            let status = props.viewer.cloudPartnerCatalog.status;
            if (props.viewer && [0,7].includes(status)) {
              return (
                <CatalogPartnerCard documentId={documentId} available={available} status={status} />
              );
            }
            return (
              <></>
            );
          }
          return (
            <></>
          );
        }}
      />
    )
  }

}

